import Layout from "../../../../global/component/Genericos/Layout/Layout";
import { useContext, useEffect, useState } from "react";
import {
  Container,
  PresenteTitle,
  ButtonContainer,
  ButtonPresente,
} from "./localstyle";
import { Geolocation } from "@capacitor/geolocation";
import { GlobalContext } from "../../../../global/context/Provider";
import ToasterV2 from "../../../../global/component/Genericos/Toaster/ToasterV2";
import { showToaster } from "../../../../global/context/action/toaster/toaster";

const UbicacionGPS = () => {
  const { toasterDispatch, toasterState } = useContext(GlobalContext);

  const [distancia, setDistancia] = useState(false);
  const [flgDistancia, setFlgDistancia] = useState(false);
  const [btnDsb, setBtnDsb] = useState(null);

  const darPresente = () => {
    alert("PRESENTE");
  };

  const toRad = (angle) => {
    return (angle * Math.PI) / 180;
  };

  const computeDistance = (lat, long) => {
    // Formula de Haversine => Calcula distancia entre 2 puntos
    Geolocation.getCurrentPosition({
      enableHighAccuracy: true,
      timeout: 10000, // espera hasta 10 segundos
      maximumAge: 0, // no uses una posición cacheada
    }).then((info) => {
      const lat1 = toRad(info.coords.latitude);
      const long1 = toRad(info.coords.longitude);
      const lat2 = toRad(-34.64124020547085);
      const long2 = toRad(-58.568093536120635);

      // En kilometros
      const result =
        6377.830272 *
        Math.acos(
          Math.sin(lat1) * Math.sin(lat2) +
            Math.cos(lat1) * Math.cos(lat2) * Math.cos(long2 - long1)
        );
      if (result <= 0.2) {
        setFlgDistancia(true);
        showToaster(
          {
            texto: "Ya podés dar el presente",
            tipo: "success",
          },
          "centroArriba"
        )(toasterDispatch);
      } else {
        setFlgDistancia(false);
        showToaster(
          {
            texto:
              "Tenés que estar a menos de 200 metros para poder dar el presente",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      }
    });
  };

  useEffect(() => {
    if (flgDistancia) {
      setDistancia(true);
    } else {
      setDistancia(false);
    }
  }, [flgDistancia]);

  return (
    <>
      {toasterState.toaster.show && <ToasterV2 />}
      <Layout>
        <Container>
          <PresenteTitle className="rb24t">
            Presioná el botón <span className="rb24b">Leer mi Ubicación</span>{" "}
            para conocer tu ubicación. Si te encontrás a menos de 200 metros del
            centro de atención podés dar el presente presionando el botón{" "}
            <span className="rb24b">Dar Presente</span>.
          </PresenteTitle>
          <ButtonContainer>
            <ButtonPresente
              className={!distancia ? "bgc-latex30" : "bgc-grey65"}
              onClick={!distancia ? computeDistance : btnDsb}
              disabled={distancia}
            >
              <p className="botonQr-text rb16b">Leer mi Ubicación</p>
            </ButtonPresente>
            <ButtonPresente
              className={!distancia ? "bgc-grey65" : "bgc-primary"}
              disabled={!distancia}
              onClick={darPresente}
            >
              <p className="botonQr-text rb16b">Dar Presente</p>
            </ButtonPresente>
          </ButtonContainer>
        </Container>
      </Layout>
    </>
  );
};

export default UbicacionGPS;
